var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("OutfitSwipe", {
    attrs: {
      visitProduct: true,
      outfitCurrent: _vm.outfitCurrent,
      noOutfitsForTheseFilters: _vm.noOutfitsForTheseFilters,
      swapProductCb: function(product) {
        return _vm.$emit("swap-product", product)
      },
      saveOutfit: _vm.saveOutfit,
      rejectOutfit: _vm.rejectOutfit
    }
  })
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fcbed21a", { render: render, staticRenderFns: staticRenderFns })
  }
}